export default __webpack_public_path__ + "images/unresolved-icon.svg";